/* eslint-disable no-undef */
/* eslint-disable space-infix-ops */
/* eslint-disable camelcase */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-const-assign */
/* eslint-disable no-return-assign */
/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-sequences */
/* eslint-disable no-param-reassign */
/* eslint-disable array-callback-return */
/* eslint-disable no-use-before-define */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable consistent-return */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-debugger */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import React, {
    useState, useEffect, useCallback, useRef,
} from 'react';
import { connect } from 'react-redux';
import Fuse from 'fuse.js';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Roles, AccessPrevileges, exceptThisSymbols } from '../../constants';
import { UserActions } from '../../redux/actions/user.action';
import { distributorService } from '../../service/distributor.service';
import { CamelCase } from '../../redux/helper/CamelCase';
import { userService } from '../../service/user.service';
import CustomToast from '../../Components/AlertPopup';
import ThreeDotsLoader from '../../Components/LoadingDots';
import AdminUpdateSkeleton from '../../Components/Skeletons/AdminUpdateSkeleton';
import { ValidateEmail } from '../../redux/helper/validateEmail';

function UpdateAdminUser({ isUpdate }) {
    const { email } = useParams();
    const history = useNavigate();
    const [territaryList, setterritaryList] = useState([]);
    const [allManagers, setAllManagers] = useState([]);
    const [constantManagers, setconstantManagers] = useState([]);
    const [threePL, setthreePL] = useState([]);
    const [Products, setProducts] = useState([]);
    const [createSuccess, setcreateSuccess] = useState(false);
    const [isLoaading, setisLoaading] = useState(true);
    const [roles, setRoles] = useState([]);
    const [roleSearchTerm, setRolesSearchTerm] = useState('');
    const [managerSearchTerm, setManagerSearchterm] = useState('');
    let created = false;
    const [conditionalRoles, sertConditionalRoles] = useState(['Area Sales Engineer', 'Service Engineer', 'Area Sales Manager', 'Regional Sales Manager', 'Sales Head']);
    const [pincodeSearchTerm, setPincodeSearchterm] = useState('');
    const [territorySearchTerm, setTerritorySearchterm] = useState('');

    // const ref = useRef();
    // const territoryRef = useRef();
    // const threepl = useRef();
    // const reporting_manager = useRef();

    // const handleClickOutside = useCallback((event) => {
    //     if (event.path[0] !== ref.current
    //         || event.path[0] !== territoryRef.current
    //         || event.path[0] !== threepl.current
    //         || event.path[0] !== reporting_manager.current
    //     ) {
    //         setTimeout(() => {
    //             handleToggle(event.target.id);
    //         });
    //     }
    // }, [ref, territoryRef, threepl, reporting_manager]);

    // useEffect(() => {
    //     document.body.addEventListener('click', handleClickOutside);
    //     return () => {
    //         // Unbind the event listener on clean up
    //         document.body.removeEventListener('click', handleClickOutside);
    //     };
    // }, [handleClickOutside]);

    const getManagers = async () => {
        const arr = [];
        const manger = await userService.getManagers();
        if (manger.data.data.length > 0) {
            manger.data.data.forEach((mng, i) => {
                mng.id = i;
                arr.push(mng);
            });
            setconstantManagers(arr);
            setAllManagers(arr);
        }
        return arr;
    };

    const getThreepl = async () => {
        const arr1 = [];
        const thpl = await userService.getthreepl();
        if (thpl.data.data.length > 0) {
            thpl.data.data.forEach((mng, i) => {
                mng.id = i;
                mng.label = mng.DESCRIPTION;
                mng.description = mng.DESCRIPTION;
                arr1.push(mng);
            });
            setthreePL(arr1);
        }
        return arr1;
    };
    const getTerritory = async () => {
        const arr2 = [];
        const territry = await userService.getTerritory();
        if (territry.data.data.length > 0) {
            territry.data.data.forEach((mng, i) => {
                mng.label = mng.NAME,
                mng.id = i;
                arr2.push(mng);
            });
            setterritaryList(arr2);
        }
        return arr2;
    };

    const getProducts = async () => {
        const arr3 = [];

        const prod = await userService.getProducts();
        if (prod.data.data.length > 0) {
            prod.data.data.forEach((mng, i) => {
                arr3.push({
                    id: `prod-${i}`, label: mng.MAIN_CATEGORY,
                });
            });
            setProducts(arr3);
        }
        return arr3;
    };

    const getRoles = async () => {
        const arr3 = [];
        const rolesData = await distributorService.getRoles();
        const roleRestiction = [];
        const rolesRest = [];
        if (rolesData.data.data.length > 0) {
            rolesData.data.data.forEach((mng, i) => {
                rolesData.data.data[i].label = mng.ROLE_NAME;
                if (mng.ROLE_SALES === 'Y') {
                    roleRestiction.push(mng.ROLE_NAME);
                    rolesRest.push(mng.ROLE_NAME.toLocaleLowerCase().replaceAll(' ', '_'));
                }
            });
            sertConditionalRoles(rolesRest);
            setRoles(rolesData.data.data);
        }
        return arr3;
    };

    const handleDependency = useCallback(

        async () => {
            const [getManger, getThreePl] = await Promise.all([getManagers(), getThreepl(), getTerritory(), getProducts(), getRoles()]).then((arr, arr1, arr2, arr3) => {
                if (isUpdate) {
                    getAdminDetails(arr, arr1, arr2, arr3);
                    handleUpdateAccessPrevelege();
                } else {
                    setisLoaading(false);
                }
            });
        },
        [],
    );

    useEffect(() => {
        handleDependency();
    }, [handleDependency]);

    const handleUpdateAccessPrevelege = (value) => {
        let arr = [];
        if (value) {
            value.forEach((item) => {
                if (!item.split('').includes(':')) {
                    arr.push(AccessPrevileges[item]);
                } else {
                    Object.keys(AccessPrevileges).map((prevelage) => {
                        if (AccessPrevileges[prevelage].length !== undefined) {
                            AccessPrevileges[prevelage].map((findData) => {
                                if (findData.value === item) {
                                    const idx = arr.map((val) => val?.id).indexOf(findData.id);
                                    if (idx === -1) {
                                        arr.push(findData);
                                    }
                                }
                            });
                        }
                    });
                }
            });
        }
        arr = arr.filter((e) => e);
        return arr;
    };

    const getAdminDetails = useCallback(
        async (manager, thripl, terr, prod) => {
            const resdata = await userService.getAdminDetail(email);
            if (resdata.data.success_status) {
                const resp = resdata.data.data;
                resp.third_party_logistics.map((item, i) => item.label = resp?.third_party_logistics[i]?.CITY);
                resp.territory.map((item, i) => item.label = resp?.territory[i]?.NAME);
                const th3pl = threePL.filter((val) => val.label).indexOf(resp.threepl);
                setState({
                    empcode: resp.employee_code,
                    first_name: resp.first_name,
                    last_name: resp.last_name,
                    email: resp.email,
                    mobile_number: resp.phone_number.slice(3),
                    territory: resp.territory,
                    role: resp.roles,
                    reporting_manager: {
                        email: resp.reporting_manager_email,
                        first_name: resp.reporting_manager_first_name,
                        last_name: resp.reporting_manager_last_name,
                    },
                    threepl: resp.third_party_logistics,
                    product_category: resp.product_categories,
                    access_previlege: handleUpdateAccessPrevelege(resp.access_privilages),
                    admin_status: resp.admin_status,
                });
                setisLoaading(false);
            }
        },
        [email],
    );
    const initialState = {
        empcode: '',
        first_name: '',
        last_name: '',
        email: '',
        mobile_number: '',
        territory: [],
        role: '',
        reporting_manager: [],
        threepl: [],
        product_category: [],
        access_previlege: [],
    };

    const initialErrorState = {
        empcode: '',
        first_name: '',
        email: '',
        mobile_number: '',
        role: '',
    };
    const accessPrevilgeState = {
        view_dashboard: '',
        manage_admin_user: [],
        manage_distributor: [],
        view3pl: '',
        view_catergories_sku: '',
        manage_deals: [],
        manage_DAP: [],
        manage_orders: [],
        pending_approvals: [],
        manage_invoices: [],
        MIS_reports: '',
        manage_resources: '',
        manage_setting: [],
        manage_banners: '',
        manage_cashback_transactions: [],
        price_list: '',
        stock_inventory: '',
    };
    const toggles = {
        territory: false,
        role: false,
        reporting_manager: false,
        threepl: false,
        product_category: false,
        manage_admin_user: false,
        manage_distributor: false,
        manage_deals: false,
        manage_DAP: false,
        manage_orders: false,
        pending_approvals: false,
        manage_invoices: false,
        manage_cashback_transactions: false,
        manage_transactions: false,
        categories: false,
        products: false,

    };
    const [state, setState] = useState(initialState);
    const [privilege, setprivilege] = useState(accessPrevilgeState);
    const [errorState, setErrorState] = useState(initialErrorState);
    const [toggleState, settoggleState] = useState(toggles);
    const [loading, setloading] = useState(false);
    const [submitSelected, setsubmitSelected] = useState(false);
    const [creatError, setcreatError] = useState('');
    const [open, setopen] = useState(false);
    const [isEmailUpdate, setIsEmailUpdate] = useState(false);

    const InputChange = (e) => {
        e.preventDefault();
        const { id, value } = e.target;
        if (value.trim() === '') {
            setState((prevState) => ({
                ...prevState,
                [id]: '',
            }));
        } else {
            setState((prevState) => ({
                ...prevState,
                [id]: value,
            }));
        }
        if (id === 'email') {
            setIsEmailUpdate(true);
        }
    };
    const handleToggle = (val) => {
        const objectCopy = { ...toggleState };
        Object.keys(objectCopy).forEach((item) => {
            if (val === item) {
                objectCopy[item] = !objectCopy[item];
            } else {
                objectCopy[item] = false;
            }
        });
        settoggleState(objectCopy);
    };
    const handleDropdown = (value, id, obj, remove) => {
        if (state.territory.length !== 0 && !conditionalRoles.includes(state.role) && id === 'territory') {
            setopen(true);
            if (!remove) {
                setcreatError('Cannot select more than one territory');
            } else {
                const arr1 = [...state[id]];
                const index = arr1.map((key) => key.label || key).indexOf(value.label || value);

                if (index <= -1) {
                    arr1.push(id === 'threepl' || id === 'territory' ? value : value.label);
                } else {
                    arr1.splice(index, 1);
                }

                setState((prevState) => ({
                    ...prevState,
                    [id]: arr1,
                }));
            }
            setTimeout(() => {
                setcreatError('');
                setopen(false);
            }, 2000);
            settoggleState((prevState) => ({
                ...prevState,
                [id]: false,
            }));
            return;
        }
        if (state.territory.length !== 0 && id === 'role') {
            setState((prevState) => ({
                ...prevState,
                territory: [],
            }));
        }

        if (obj === undefined) {
            if (id === 'role') {
                value.label = value.label.replaceAll(' ', '_').toLowerCase();
            }
            setState((prevState) => ({
                ...prevState,
                [id]: id === 'reporting_manager' ? value : value.label,
            }));
        } else {
            const arr = [...state[id]];
            const index = arr.map((key) => key.label || key).indexOf(value.label || value);

            if (index <= -1) {
                arr.push(id === 'threepl' || id === 'territory' ? value : value.label);
            } else {
                arr.splice(index, 1);
            }

            setState((prevState) => ({
                ...prevState,
                [id]: arr,
            }));
        }

        settoggleState((prevState) => ({
            ...prevState,
            [id]: false,
        }));
    };
    const handleAccessPrevilege = (previlege) => {
        const prvArr = [...state.access_previlege];
        const index = prvArr.map((key) => key.id).indexOf(previlege.id);
        if (index === -1) {
            prvArr.push(previlege);
        } else {
            prvArr.splice(index, 1);
        }
        setState((prevState) => ({
            ...prevState,
            access_previlege: prvArr,
        }));
    };
    // handling previliged check box
    const handleAllPrevilage = (item, obj) => {
        let tempArr = [...state.access_previlege];
        if (obj === undefined) {
            const objIndex = tempArr.map((key) => key.id).indexOf(item.id);
            if (objIndex === -1) {
                tempArr.push(item);
            } else {
                tempArr.splice(objIndex, 1);
            }
        } else {
            const key = item[0].value.split(':')[0];
            const filterValue = [];
            tempArr.filter((val) => {
                if (val.value.split(':')[0] === key) {
                    filterValue.push(val);
                }
            });
            if (filterValue.length === item.length) {
                tempArr = tempArr.filter((val) => val.value.split(':')[0] !== key);
            } else {
                tempArr = tempArr.filter((val) => val.value.split(':')[0] !== key);
                const temp = [];
                item.forEach((value) => {
                    tempArr.push(value);
                });
            }
        }
        setState((prevState) => ({
            ...prevState,
            access_previlege: tempArr,
        }));
    };
    const ItemExist = (id) => {
        let val = false;
        if (state.access_previlege.length > 0) {
            val = !(state.access_previlege.map((item) => item?.id).indexOf(id) <= -1);
        }
        return val;
    };
    // check parent and child has same items
    const parentCheckStatus = (items) => {
        const key = items[0].value.split(':')[0];
        const arrcopy = [...state.access_previlege];
        const filterValue = arrcopy.filter((val) => val?.value.split(':')[0] === key);
        return filterValue.length > 0;
    };
    const validate = () => {
        let isvalid = true;
        Object.keys(state).forEach((key) => {
            switch (key) {
            case 'empcode':
            case 'first_name':
            case 'email':
            case 'mobile_number':
            case 'role':
                if (state[key] === '') {
                    setErrorState((prevState) => ({
                        ...prevState,
                        [key]: `${key} is required`,
                    }));
                    isvalid = false;
                }
                break;
            default: break;
            }
        });
        return isvalid;
    };
    const getPrevilage = () => {
        const prevelage = [];
        state.access_previlege.forEach((item) => {
            if (item) {
                prevelage.push(item.value);
            }
        });
        return prevelage;
    };
    function Error() {
        return (
            <p className=" text-[#090406] font-medium pl-[54px] py-3" style={{ fontSize: '15px', color: '#808285' }}>
                {creatError}
            </p>
        );
    }
    function Success() {
        return (
            <p className=" text-[#090406] font-medium pl-[54px] py-3" style={{ fontSize: '15px', color: '#808285' }}>
                Internal User
                {' '}
                <>{`${isUpdate ? 'Updated' : 'Added'}`}</>
                {' '}
                Successfully!!
            </p>
        );
    }
    const get3Pl = (obj) => {
        const arr = [];
        obj.forEach((val) => {
            arr.id = undefined;
            arr.label = undefined;
            arr.push({
                CITY: val.CITY,
                DESCRIPTION: val.DESCRIPTION,
                IS_ACTIVE_FLAG: val.IS_ACTIVE_FLAG,
                OPERATING_UNIT_ID: String(val.OPERATING_UNIT_ID),
                ORGANIZATION_CODE: val.ORGANIZATION_CODE,
                ORGANIZATION_ID: String(val.ORGANIZATION_ID),
                ORGANIZATION_NAME: val.ORGANIZATION_NAME,
                STATE: val.STATE === null ? 'null' : val.STATE,
            });
        });
        return arr;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorState({
            first_name: '',
            email: '',
            mobile_number: '',
            role: '',
            empcode: '',
        });
        setloading(true);
        setsubmitSelected(true);
        let payload = {};
        if (!validate()) {
            setloading(false);
            return;
        }
        if (!ValidateEmail(state.email)) {
            setErrorState((prevState) => ({
                ...prevState,
                email: 'Please enter Valid email Address',
            }));

            setloading(false);
            return;
        }
        if (state.role !== '' && state.reporting_manager.length === 0) {
            setloading(false);
            return;
        }
        if (conditionalRoles.includes(state.role) && state.product_category.length === 0) {
            setloading(false);
            return;
        }
        if (state.mobile_number.length > 0 && state.mobile_number.length !== 10) {
            setloading(false);
            return;
        }
        const territoryListcreate = [];
        state.territory.forEach((val) => {
            territoryListcreate.push({
                NAME: val.NAME,
                TERRITORY_CODE: String(val.TERRITORY_CODE),
                TERRITORY_ID: String(val.TERRITORY_ID),
            });
        });
        if (isUpdate) {
            payload = {
                first_name: state.first_name,
                last_name: state.last_name,
                phone_number: `+91${state.mobile_number}`,
                territory: state.territory,
                roles: state.role.replace(/\s/g, '_').toLocaleLowerCase(),
                third_party_logistics: get3Pl(state.threepl),
                product_categories: state.product_category,
                access_privilages: getPrevilage(),
                admin_status: state.admin_status,
                reporting_manager_email: state.reporting_manager.email,
                reporting_manager_first_name: state.reporting_manager.first_name,
                reporting_manager_last_name: state.reporting_manager.last_name,
            };
            if (isEmailUpdate === true) {
                payload.email = state.email;
            }
        } else {
            payload = {
                employee_code: state.empcode,
                first_name: state.first_name,
                last_name: state.last_name,
                email: state.email,
                phone_number: `+91${state.mobile_number}`,
                territory: territoryListcreate,
                roles: state.role.replace(/\s/g, '_').toLocaleLowerCase(),
                third_party_logistics: get3Pl(state.threepl),
                product_categories: state.product_category,
                access_privilages: getPrevilage(),
                admin_status: '1',
                reporting_manager_email: state.reporting_manager.email,
                reporting_manager_first_name: state.reporting_manager.first_name,
                reporting_manager_last_name: state.reporting_manager.last_name,
            };
        }

        let create;
        if (isUpdate) {
            create = await userService.UserActiveOrDeactive(payload, email);
        } else {
            create = await userService.createUser(payload, email);
        }
        if (!create.error) {
            setcreateSuccess(true);
            created = true;
            setInterval(() => {
                window.location.href = '/manage-internal-users';
            }, 3000);
        } else {
            setopen(true);
            setcreatError(create.message);
            setTimeout(() => {
                setcreatError('');
            }, 2000);
            setloading(false);
        }
    };
    const findItemExist = (key, val) => state[key].map((item) => item.label).indexOf(val.label);

    const roleSearchHandler = (value) => {
        if (roleSearchTerm === '') {
            return value;
        } if ((value.ROLE_NAME).toLowerCase().includes(roleSearchTerm.toLowerCase())) {
            return value;
        }
    };

    const fuse = new Fuse(constantManagers, {
        keys: [
            'first_name',
            'last_name',
            'employee_code',
        ],
        includeScore: true,

    });

    const managerSearchHandler = async (searchTerm) => {
        setManagerSearchterm(searchTerm);
        if (searchTerm === '') {
            setconstantManagers(allManagers);
        } else {
            const searchedManagers = allManagers.filter((manager) => manager.first_name.toLowerCase().includes(searchTerm.toLowerCase()) || manager.last_name.toLowerCase().includes(searchTerm.toLowerCase()) || manager.employee_code.toLowerCase().includes(searchTerm.toLowerCase()) || manager.email.toLowerCase().includes(searchTerm.toLowerCase()));
            setconstantManagers(searchedManagers);
        }
    };

    const pincodeSearchHandler = (pincodeValue) => {
        if (pincodeSearchTerm === '') {
            return pincodeValue;
        } if ((pincodeValue.DESCRIPTION).toLowerCase().includes(pincodeSearchTerm.toLowerCase())) {
            return pincodeValue;
        }
    };

    const territorySearchHandler = (territoryValue) => {
        if (territorySearchTerm === '') {
            return territoryValue;
        } if ((territoryValue.NAME).toLowerCase().includes(territorySearchTerm.toLowerCase())) {
            return territoryValue;
        }
    };

    return (
        <div className="py-6 px-12 w-full">
            {creatError !== '' && (
                <CustomToast
                    open={open}
                    color="#ED1C24"
                    setopen={setopen}
                    message={<Error />}
                />
            )}
            <div className="flex items-center">
                {createSuccess && (
                    <CustomToast
                        open
                        message={<Success />}
                    />
                )}
                <Link to="/manage-internal-users">
                    <img src="/images/Icon-feather-arrow-left.svg" alt="icon" />
                </Link>
                <p className="text-xs4 font-normal text-[#555259] pl-4">
                    {isUpdate ? 'Update' : 'Add New'}
                    {' '}
                    Admin User
                </p>
            </div>
            {isLoaading ? <AdminUpdateSkeleton />
                : (
                    <div className="pt-12">
                        <form onSubmit={(e) => handleSubmit(e)} noValidate>
                            <div className="pb-[30px] border-b border-[#F2F2F3]">
                                <div className="flex w-full">
                                    <div className="relative w-1/3">
                                        <input
                                            type="text"
                                            id="empcode"
                                            disabled={isUpdate}
                                            value={state.empcode}
                                            onChange={(e) => InputChange(e)}
                                            className={`h-12 w-full rounded-lg outline-0 border  bg-[#FFFFFF] text-lg  font-normal text-[#090406] px-3 border-[#${submitSelected && errorState.empcode !== '' ? 'ED1C24' : 'B1B4B7'}]`}
                                            autoComplete="off"
                                            placeholder="Enter Employee Code"
                                            onFocus={() => {
                                                setsubmitSelected(false);
                                            }}
                                        />
                                        <label htmlFor="empcode" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">Employee Code *</label>
                                        {submitSelected && errorState.empcode !== '' && <span className="text-s font-light text-[#ED1C24]">Employee code is required</span>}

                                    </div>
                                    <div className="relative w-1/3 ml-8">
                                        <input
                                            type="text"
                                            onChange={(e) => InputChange(e)}
                                            id="first_name"
                                            value={state.first_name}
                                            className={`h-12 w-full rounded-lg outline-0 border  bg-[#FFFFFF] text-lg  font-normal text-[#090406] px-3 border-[#${submitSelected && errorState.first_name !== '' ? 'ED1C24' : 'B1B4B7'}]`}
                                            autoComplete="off"
                                            placeholder="Enter First Name"
                                            onFocus={() => {
                                                setsubmitSelected(false);
                                            }}
                                            // onInput={(e) => { e.target.value = e.target.value.replace(/[^A-Za-z]/ig, ''); }}
                                        />
                                        <label htmlFor="first_name" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">First Name *</label>
                                        {submitSelected && errorState.first_name !== '' && <span className="text-s font-light text-[#ED1C24]">First name is required</span>}
                                    </div>
                                    <div className="relative w-1/3 ml-8">
                                        <input
                                            type="text"
                                            onChange={(e) => InputChange(e)}
                                            id="last_name"
                                            value={state.last_name}
                                            placeholder="Enter Last Name"
                                            className="h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg  font-normal text-[#090406] px-3"
                                            autoComplete="off"
                                        />
                                        <label htmlFor="last_name" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">Last Name</label>
                                    </div>
                                </div>
                                <div className="flex w-full pt-[26px]">
                                    <div className="relative w-1/3">
                                        <input
                                            type="email"
                                            onChange={(e) => InputChange(e)}
                                            id="email"
                                            value={state.email}
                                            placeholder="Enter Email Address"
                                            onFocus={() => {
                                                setsubmitSelected(false);
                                            }}
                                            className={`h-12 w-full rounded-lg outline-0 border  bg-[#FFFFFF] text-lg  font-normal text-[#090406] px-3 border-[#${submitSelected && errorState.email !== '' ? 'ED1C24' : 'B1B4B7'}]`}
                                            autoComplete="off"
                                        />
                                        <label htmlFor="email" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">Email Address *</label>
                                        {submitSelected && (state.email.length === 0 && errorState.email !== '') && <span className="text-s font-light text-[#ED1C24]">Email address is required</span>}
                                        <br />
                                        {submitSelected && (state.email.length > 0 && errorState.email !== '') && <span className="text-s font-light text-[#ED1C24]">Please enter a valid Email Address</span>}
                                    </div>
                                    <div className="relative w-1/3 ml-8">
                                        <input
                                            type="number"
                                            onChange={(e) => InputChange(e)}
                                            id="mobile_number"
                                            className={`h-12 w-full rounded-lg outline-0 border  bg-[#FFFFFF] text-lg  font-normal text-[#090406] px-3 border-[#${submitSelected && errorState.mobile_number !== '' ? 'ED1C24' : 'B1B4B7'}]`}
                                            autoComplete="off"
                                            placeholder="Enter 10 Digit Mobile Number"
                                            maxLength="10"
                                            minLength="10"
                                            value={state.mobile_number}
                                            onKeyDown={(e) => (exceptThisSymbols.includes(e.key) && e.preventDefault())}
                                        />
                                        <label htmlFor="mobile_number" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">Mobile Number *</label>
                                        {submitSelected && errorState.mobile_number !== '' && <span className="text-s font-light text-[#ED1C24]">Mobile number is required</span>}
                                        <br />
                                        {submitSelected && (state.mobile_number.length > 0 && state.mobile_number.length !== 10) && <span className="text-s font-light text-[#ED1C24]">Mobile number should be 10 digit</span>}

                                    </div>
                                    <div className="dropdown relative w-1/3 ml-8">
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setsubmitSelected(false);
                                                handleToggle('role');
                                            }}
                                            // ref={ref}
                                            id="role"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            className={`h-12 text-left w-full rounded-lg outline-0 border bg-[#FFFFFF] text-lg  font-normal text-[#090406] px-3 border-[#${submitSelected && errorState.role !== '' ? 'ED1C24' : 'B1B4B7'}]`}
                                        >
                                            <span className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                                Role *
                                            </span>
                                            {state.role === '' ? <p id="role" style={{ color: 'grey' }}>Please Select Role</p> : CamelCase(state.role?.replace(/_/g, ' '))}
                                            {state.role === '' ? <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5 default-dropdown cursor-pointer" />
                                                : <img src="/images/chevron-red-down.svg" alt="icon" className="absolute top-[22px] right-5 selected selected-dropdown cursor-pointer" />}
                                        </button>
                                        {submitSelected && errorState.role !== '' && <span className="text-s font-light text-[#ED1C24]">Role is required</span>}

                                        <ul className={`dropdown-menu w-full absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${toggleState.role ? 'overflow-auto h-32' : ''}`} aria-labelledby="territory">
                                            <input
                                                type="text"
                                                name="search"
                                                id="search"
                                                autoComplete="off"
                                                // value={roleSearchTerm}
                                                onChange={(e) => {
                                                    setRolesSearchTerm(e.target.value);
                                                }}
                                                className={`w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg ${toggleState.role ? 'show' : 'hidden'}`}
                                                placeholder="Search"
                                            />
                                            {
                                                toggleState.role && roles.filter((value) => roleSearchHandler(value)).map((roleval) => (
                                                    <>
                                                        <li className="pl-10 w-full pt-3" key={`r-${roleval.id}`}>
                                                            <a className="dropdown-item text-lg font-normal text-[#555259] w-full inline-block territory-inp" href="javascript:void(0)" onClick={() => handleDropdown(roleval, 'role')}>{roleval.ROLE_NAME}</a>
                                                        </li>
                                                    </>
                                                ))
                                            }

                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="pt-[30px]">
                                <div className="flex">
                                    <div className="dropdown relative w-2/5">
                                        <button
                                            onClick={() => handleToggle('territory')}
                                            type="button"
                                            // ref={territoryRef}
                                            id="territory"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            className="h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg  font-normal text-[#090406] px-3 text-left"
                                        >
                                            <span className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF] ">
                                                Territory
                                            </span>
                                            {state.territory.length === 0 ? (
                                                <p style={{ color: 'grey' }} id="territory">
                                                    Please Select Territory
                                                </p>
                                            ) : <>{state.territory[0].label}</>}
                                            {state.territory.length === 0 ? <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5 default-dropdown" />
                                                : <img src="/images/chevron-red-down.svg" alt="icon" className="absolute top-[22px] right-5  selected selected-dropdown" />}
                                        </button>
                                        <ul className={`dropdown-menu w-full absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${toggleState.territory ? 'overflow-auto h-32' : ''}`} aria-labelledby="territory">
                                            <input
                                                type="text"
                                                name="search"
                                                id="search"
                                                autoComplete="off"
                                                // value={searchValue || ''}
                                                onChange={(e) => {
                                                    setTerritorySearchterm((e.target.value));
                                                }}
                                                className={`w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg ${toggleState.territory ? 'show' : 'hidden'}`}
                                                placeholder="Search"
                                            />
                                            {toggleState.territory && territaryList.filter((territoryValue) => territorySearchHandler(territoryValue)).map((threeplValue) => (
                                                <li className="pl-10 w-full pt-2" key={`three-${threeplValue.label}`}>

                                                    <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3">
                                                        <input
                                                            type="checkbox"
                                                            id={`checkbox-${threeplValue.id}`}
                                                            onChange={() => {
                                                                handleDropdown(threeplValue, 'territory', 'object');
                                                            }}
                                                            checked={findItemExist('territory', threeplValue) > -1}
                                                        />
                                                        <label htmlFor={`checkbox-${threeplValue.id}`} className="text-sm font-normal text-[#555259] pl-2">{threeplValue.label}</label>
                                                    </div>
                                                </li>
                                            ))}

                                        </ul>
                                        <div className="flex pt-2.5 flex-wrap w-full ">
                                            { state.territory.length > 0 && state.territory.map((selectedTerritory) => (

                                                <div className="flex bg-[#F2F2F3] rounded-lg mt-2   ml-2  px-2 py-2 w-[120px] h-[33px] cursor-pointer items-center justify-center">
                                                    <p className="text-sm font-normal text-[#555259]">{selectedTerritory.label.length > 9 ? `${selectedTerritory.label.substring(0, 9)}...` : selectedTerritory.label}</p>
                                                    <img src="/images/cross-mark.svg" alt="icon" className="pl-2 w-4" onClick={() => handleDropdown(selectedTerritory, 'territory', 'object', 'remove')} />
                                                </div>

                                            ))}
                                        </div>
                                    </div>
                                    <div className="dropdown relative w-2/5 ml-8">
                                        <button
                                            onClick={() => handleToggle('reporting_manager')}
                                            type="button"
                                            id="reporting_manager"
                                            // ref={reporting_manager}
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            className={`h-12 text-left w-full rounded-lg outline-0 border bg-[#FFFFFF] text-lg  font-normal text-[#090406] px-3 ${submitSelected && state.role === 'Area Sales Engineer' && state.reporting_manager.length === 0 ? 'border-[#ED1C24]' : 'border-[#B1B4B7]'}`}
                                        >
                                            <span className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                                Reporting Manager *
                                            </span>
                                            {state.reporting_manager.length === 0 ? <p style={{ color: 'grey' }} id="reporting_manager">Please Select Reporting Manager</p> : <>{`${state.reporting_manager.first_name} ${state.reporting_manager.last_name}`}</>}
                                            {state.reporting_manager.length === 0 ? <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5 default-dropdown" />
                                                : <img src="/images/chevron-red-down.svg" alt="icon" className="absolute top-[22px] right-5  selected selected-dropdown" />}
                                        </button>
                                        {submitSelected && state.role !== '' && state.reporting_manager.length === 0 && (
                                            <span className="text-s font-light text-[#ED1C24]">Please select reporting manager</span>)}

                                        <ul className={`dropdown-menu w-full absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${toggleState.reporting_manager ? 'overflow-auto h-32' : ''}`} aria-labelledby="territory">
                                            <input
                                                type="text"
                                                name="search"
                                                id="search"
                                                autoComplete="off"
                                                value={managerSearchTerm}
                                                onChange={(e) => {
                                                    managerSearchHandler((e.target.value));
                                                }}
                                                className={`w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg ${toggleState.reporting_manager ? 'show' : 'hidden'}`}
                                                placeholder="Search"
                                            />
                                            { toggleState.reporting_manager && constantManagers.map((manager) => (
                                                <li className="pl-10 w-full pt-3">
                                                    <a
                                                        className="dropdown-item text-lg font-normal text-[#555259] w-full inline-block territory-inp"
                                                        href="javascript:void(0)"
                                                        onClick={() => handleDropdown(manager, 'reporting_manager')}
                                                    >
                                                        {manager.first_name}
                                                        {' '}
                                                        {manager.last_name}
                                                        {' '}
                                                        (
                                                        {manager.employee_code}
                                                        )

                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="pt-[26px] flex">
                                    <div className="dropdown relative w-2/5">
                                        <button
                                            onClick={() => handleToggle('threepl')}
                                            type="button"
                                            id="threepl"
                                            // ref={threepl}
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            className="h-12 w-full text-left rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg  font-normal text-[#090406] px-3"
                                        >
                                            <span className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF] selected-field">
                                                3PL
                                            </span>
                                            {state.threepl.length === 0 && <p style={{ color: 'grey' }} id="threepl">Please Select 3PL</p>}
                                        </button>
                                        {state.threepl.length === 0 ? <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5 default-dropdown" />
                                            : <img src="/images/chevron-red-down.svg" alt="icon" className="absolute top-[22px] right-5  selected selected-dropdown" />}
                                        <ul className={`dropdown-menu w-full absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${toggleState.threepl ? 'overflow-auto h-32' : ''}`} aria-labelledby="territory">
                                            <input
                                                type="text"
                                                name="search"
                                                id="search"
                                                autoComplete="off"
                                                // value={searchValue || ''}
                                                onChange={(e) => {
                                                    setPincodeSearchterm((e.target.value));
                                                }}
                                                className={`w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg ${toggleState.threepl ? 'show' : 'hidden'}`}
                                                placeholder="Search"
                                            />
                                            {toggleState.threepl && threePL.filter((pincodeValue) => pincodeSearchHandler(pincodeValue)).map((threeplValue) => (
                                                <li className="pl-10 w-full pt-2" key={`three-${threeplValue.label}`}>

                                                    <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3">
                                                        <input
                                                            type="checkbox"
                                                            id={`checkbox-${threeplValue.id}`}
                                                            onChange={() => {
                                                                handleDropdown(threeplValue, 'threepl', 'object');
                                                            }}
                                                            checked={findItemExist('threepl', threeplValue) > -1}
                                                        />
                                                        <label htmlFor={`checkbox-${threeplValue.id}`} className="text-sm font-normal text-[#555259] pl-2">
                                                            {threeplValue.description}
                                                        </label>
                                                    </div>
                                                </li>
                                            ))}

                                        </ul>
                                        <div className="flex pt-2.5 flex-wrap w-full ">
                                            { state.threepl.length > 0 && state.threepl.map((selected3pl) => (
                                                <div className="flex bg-[#F2F2F3] rounded-lg mt-2   ml-2  px-2 py-2 w-[125px] h-[35px] cursor-pointer items-center justify-center">
                                                    <p className="text-sm font-normal text-[#555259]">{selected3pl.DESCRIPTION}</p>
                                                    <img src="/images/cross-mark.svg" alt="icon" className="pl-2 w-4" onClick={() => handleDropdown(selected3pl, 'threepl', 'object')} />
                                                </div>

                                            ))}
                                        </div>

                                    </div>
                                    <div className={`dropdown relative w-2/5 ml-8 ${conditionalRoles.includes(state.role) ? '' : 'hidden'}`}>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setsubmitSelected(false);
                                                handleToggle('product_category');
                                            }}
                                            id="territory"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            className={`h-12 w-full text-left rounded-lg outline-0 border bg-[#FFFFFF] text-lg  font-normal text-[#090406] px-3 ${submitSelected && state.role === 'Area Sales Engineer' && state.product_category.length === 0 ? 'border-[#ED1C24]' : 'border-[#B1B4B7]'}`}
                                        >
                                            <span className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                                Product Category *
                                            </span>
                                            {state.product_category.length === 0 && <p style={{ color: 'grey' }}>Please Select Product Category</p>}
                                            {state.product_category.length === 0 ? <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5 default-dropdown" />
                                                : <img src="/images/chevron-red-down.svg" alt="icon" className="absolute top-[22px] right-5  selected selected-dropdown" />}
                                        </button>
                                        {submitSelected && conditionalRoles.includes(state.role) && state.product_category.length === 0 && (
                                            <span className="text-s font-light text-[#ED1C24]">Please select product category</span>)}
                                        <ul className="dropdown-menu w-full absolute  bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999]" aria-labelledby="territory">

                                            {toggleState.product_category && Products.map((prod) => (

                                                <li className="pl-10 w-full pt-2" key={`three-${prod.label}`}>

                                                    <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3">
                                                        <input
                                                            type="checkbox"
                                                            id={`checkbox-${prod.id}`}
                                                            onChange={() => {
                                                                handleDropdown(prod, 'product_category', 'object');
                                                            }}
                                                            checked={state.product_category.includes(prod.label)}
                                                        />
                                                        <label htmlFor={`checkbox-${prod.id}`} className="text-sm font-normal text-[#555259] pl-2">{prod.label}</label>
                                                    </div>
                                                </li>
                                            ))}

                                        </ul>
                                        <div className=" flex flex-wrap w-full">
                                            { state.product_category.length > 0 && state.product_category.map((selectdProduct) => (
                                                <div className="flex bg-[#F2F2F3] rounded-lg mt-2   ml-2  px-2 py-2 w-[120px] h-[33px] cursor-pointer items-center justify-center">
                                                    <p className="text-sm font-normal text-[#555259]">{selectdProduct}</p>
                                                    <img src="/images/cross-mark.svg" alt="icon" className="pl-2 w-4" onClick={() => handleDropdown(selectdProduct, 'product_category', 'object')} />
                                                </div>

                                            ))}
                                        </div>
                                    </div>

                                </div>

                            </div>

                            <div className="pt-6">
                                <p className="text-sm font-bold text-[#090406]">Access Privileges</p>
                                <div className="pt-6">
                                    <div className="flex pb-3">
                                        <div className="relative checkbox custom-checkbox custom-checkbox1 bg-[#FFFFFF] h-[52px] rounded-lg shadow-s4 py-4 pl-5 w-1/3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                id="checkbox-view"
                                                checked={ItemExist(AccessPrevileges.view_dashboard.id)}
                                                onChange={() => handleAllPrevilage(AccessPrevileges.view_dashboard)}
                                            />
                                            <label htmlFor="checkbox-view" className="text-sm font-normal text-[#555259] pl-2 w-full"> Dashboard</label>
                                        </div>
                                        <div className="ml-8 dropdown relative w-1/3">
                                            <button
                                                onClick={() => handleToggle('manage_admin_user')}
                                                type="button"
                                                id="territory"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                className="customrotate alignLeft h-12 w-full rounded-lg outline-0 shadow-s4 bg-[#FFFFFF] text-sm font-normal text-[#555259] px-3"
                                            >
                                                Admin Users
                                                {toggleState.manage_admin_user === false ? <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5 default-dropdown" />
                                                    : <img src="/images/chevron-red-down.svg" alt="icon" className="absolute top-[22px] right-5  selected selected-dropdown" />}
                                            </button>
                                            <ul className={`dropdown-menu w-full absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${toggleState.manage_admin_user ? 'overflow-auto h-32' : ''}`} aria-labelledby="territory">
                                                {toggleState.manage_admin_user && AccessPrevileges.manage_admin_users.map((adminuser) => (
                                                    <li className="pl-10 w-full pt-4" key={adminuser.id}>
                                                        <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3">
                                                            <input type="checkbox" id={`checkbox-d1${adminuser.id}`} checked={ItemExist(adminuser.id)} onChange={() => handleAccessPrevilege(adminuser)} />
                                                            <label htmlFor={`checkbox-d1${adminuser.id}`} className="text-sm font-normal text-[#555259] pl-2">{CamelCase(adminuser.label)}</label>
                                                        </div>
                                                    </li>
                                                ))}

                                            </ul>
                                            <div className="absolute -top-[4px] left-0">
                                                <div className="relative checkbox custom-checkbox custom-checkbox1 pb-3">
                                                    <input type="checkbox" id="checkbox-view1" onChange={() => handleAllPrevilage(AccessPrevileges.manage_admin_users, 'Obj')} checked={parentCheckStatus(AccessPrevileges.manage_admin_users)} />
                                                    <label htmlFor="checkbox-view1" className="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="ml-8 dropdown relative w-1/3">
                                            <button
                                                onClick={() => handleToggle('manage_distributor')}
                                                type="button"
                                                id="territory"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                className="customrotate alignLeft h-12 w-full rounded-lg outline-0 shadow-s4 bg-[#FFFFFF] text-sm font-normal text-[#555259] px-3"
                                            >
                                                Distributors/Customers
                                                {toggleState.manage_distributor === false ? <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5 default-dropdown" style={{ right: '0.25rem' }} />
                                                    : <img src="/images/chevron-red-down.svg" alt="icon" className="absolute top-[22px] right-5  selected selected-dropdown" style={{ right: '0.25rem' }} />}
                                            </button>
                                            <ul className={`dropdown-menu w-full absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${toggleState.manage_distributor ? 'overflow-auto h-32' : ''}`} aria-labelledby="territory">

                                                {toggleState.manage_distributor && AccessPrevileges.manage_distributor.map((distributor) => (
                                                    <li className="pl-10 w-full pt-4" key={distributor.id}>
                                                        <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3">
                                                            <input
                                                                type="checkbox"
                                                                id={`checkbox-d1${distributor.id}`}
                                                                checked={ItemExist(distributor.id)}
                                                                onChange={() => handleAccessPrevilege(distributor)}
                                                            />
                                                            <label htmlFor={`checkbox-d1${distributor.id}`} className="text-sm font-normal text-[#555259] pl-2">{distributor.label}</label>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>

                                            <div className="absolute -top-[4px] left-0">
                                                <div className="relative checkbox custom-checkbox custom-checkbox3 pb-3">
                                                    <input
                                                        type="checkbox"
                                                        id="checkbox-view91"
                                                        onChange={() => handleAllPrevilage(AccessPrevileges.manage_distributor, 'Obj')}
                                                        checked={parentCheckStatus(AccessPrevileges.manage_distributor)}
                                                    />
                                                    <label htmlFor="checkbox-view91" className="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex pb-3">
                                        <div className="relative checkbox custom-checkbox custom-checkbox1 bg-[#FFFFFF] h-[52px] rounded-lg shadow-s4 py-4 pl-5 w-1/3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                id="checkbox-s1"
                                                checked={ItemExist(AccessPrevileges.view_3pls.id)}
                                                onChange={() => handleAllPrevilage(AccessPrevileges.view_3pls)}
                                            />
                                            <label htmlFor="checkbox-s1" className="text-sm font-normal text-[#555259] pl-2 w-full">Shipping Organization (3PL)</label>
                                        </div>
                                        <div className="relative checkbox custom-checkbox custom-checkbox1 bg-[#FFFFFF] ml-8 h-[52px] rounded-lg shadow-s4 py-4 pl-5 w-1/3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                id="checkbox-s2"
                                                checked={ItemExist(AccessPrevileges.view_categories.id)}
                                                onChange={() => handleAllPrevilage(AccessPrevileges.view_categories)}
                                            />
                                            <label htmlFor="checkbox-s2" className="text-sm font-normal text-[#555259] pl-2 w-full">Categories and SKU’s</label>
                                        </div>
                                        <div className="ml-8 dropdown relative w-1/3">
                                            <button
                                                onClick={() => handleToggle('manage_deals')}
                                                type="button"
                                                id="territory"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                className="customrotate alignLeft h-12 w-full rounded-lg outline-0 shadow-s4 bg-[#FFFFFF] text-sm font-normal text-[#555259] px-3"
                                            >
                                                Trade & Commercial Policy/Offer
                                                {toggleState.manage_deals === false ? <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5 default-dropdown" />
                                                    : <img src="/images/chevron-red-down.svg" alt="icon" className="absolute top-[22px] right-5  selected selected-dropdown" />}
                                            </button>
                                            <ul className={`dropdown-menu w-full absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${toggleState.manage_deals ? 'overflow-auto h-32' : ''}`} aria-labelledby="territory">

                                                {toggleState.manage_deals && AccessPrevileges.manage_deals.map((distributor) => (
                                                    <li className="pl-10 w-full pt-4" key={distributor.id}>
                                                        <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3">
                                                            <input
                                                                type="checkbox"
                                                                id={`checkbox-d1${distributor.id}`}
                                                                checked={ItemExist(distributor.id)}
                                                                onChange={() => handleAccessPrevilege(distributor)}
                                                            />
                                                            <label htmlFor={`checkbox-d1${distributor.id}`} className="text-sm font-normal text-[#555259] pl-2">{distributor.label}</label>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                            <div className="absolute -top-[4px] left-0">
                                                <div className="relative checkbox custom-checkbox custom-checkbox1 pb-3">
                                                    <input
                                                        type="checkbox"
                                                        id="checkbox-view31"
                                                        onChange={() => handleAllPrevilage(AccessPrevileges.manage_deals, 'Obj')}
                                                        checked={parentCheckStatus(AccessPrevileges.manage_deals)}
                                                    />
                                                    <label htmlFor="checkbox-view31" className="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex pb-3">
                                        <div className="dropdown relative w-1/3">
                                            <button
                                                onClick={() => handleToggle('manage_DAP')}
                                                type="button"
                                                id="territory"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                className="customrotate alignLeft h-12 w-full rounded-lg outline-0 shadow-s4 bg-[#FFFFFF] text-sm font-normal text-[#555259] px-3"
                                            >
                                                Freight Policy (DAP)
                                                {toggleState.manage_DAP === false ? <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5 default-dropdown" />
                                                    : <img src="/images/chevron-red-down.svg" alt="icon" className="absolute top-[22px] right-5  selected selected-dropdown" />}
                                            </button>
                                            <ul className={`dropdown-menu w-full absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${toggleState.manage_DAP ? 'overflow-auto h-32' : ''}`} aria-labelledby="territory">

                                                {toggleState.manage_DAP && AccessPrevileges.manage_DAP.map((dap) => (
                                                    <li className="pl-10 w-full pt-4" key={dap.id}>
                                                        <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3">
                                                            <input
                                                                type="checkbox"
                                                                id={`checkbox-d1${dap.id}`}
                                                                checked={ItemExist(dap.id)}
                                                                onChange={() => handleAccessPrevilege(dap)}
                                                            />
                                                            <label htmlFor={`checkbox-d1${dap.id}`} className="text-sm font-normal text-[#555259] pl-2">{dap.label}</label>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                            <div className="absolute -top-[4px] left-0">
                                                <div className="relative checkbox custom-checkbox custom-checkbox1 pb-3">
                                                    <input
                                                        type="checkbox"
                                                        id="checkbox-view19"
                                                        onChange={() => handleAllPrevilage(AccessPrevileges.manage_DAP, 'Obj')}
                                                        checked={parentCheckStatus(AccessPrevileges.manage_DAP)}
                                                    />
                                                    <label htmlFor="checkbox-view19" className="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="ml-8 dropdown relative w-1/3">
                                            <button
                                                onClick={() => handleToggle('manage_orders')}
                                                type="button"
                                                id="territory"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                className="customrotate alignLeft h-12 w-full rounded-lg outline-0 shadow-s4 bg-[#FFFFFF] text-sm font-normal text-[#555259] px-3"
                                            >
                                                Orders
                                                {toggleState.manage_orders === false ? <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5 default-dropdown" />
                                                    : <img src="/images/chevron-red-down.svg" alt="icon" className="absolute top-[22px] right-5  selected selected-dropdown" />}
                                            </button>

                                            <ul className={`dropdown-menu w-full absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${toggleState.manage_orders ? 'overflow-auto h-32' : ''}`} aria-labelledby="territory">

                                                {toggleState.manage_orders && AccessPrevileges.manage_orders.map((dap) => (
                                                    <li className="pl-10 w-full pt-4" key={dap.id}>
                                                        <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3">
                                                            <input
                                                                type="checkbox"
                                                                id={`checkbox-d1${dap.id}`}
                                                                checked={ItemExist(dap.id)}
                                                                onChange={() => handleAccessPrevilege(dap)}
                                                            />
                                                            <label htmlFor={`checkbox-d1${dap.id}`} className="text-sm font-normal text-[#555259] pl-2">{dap.label}</label>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                            <div className="absolute -top-[4px] left-0">
                                                <div className="relative checkbox custom-checkbox custom-checkbox1 pb-3">
                                                    <input
                                                        type="checkbox"
                                                        id="checkbox-view20"
                                                        onChange={() => handleAllPrevilage(AccessPrevileges.manage_orders, 'Obj')}
                                                        checked={parentCheckStatus(AccessPrevileges.manage_orders)}
                                                    />
                                                    <label htmlFor="checkbox-view20" className="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="ml-8 dropdown relative w-1/3">
                                            <button
                                                onClick={() => handleToggle('pending_approvals')}
                                                type="button"
                                                id="territory"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                className="customrotate alignLeft h-12 w-full rounded-lg outline-0 shadow-s4 bg-[#FFFFFF] text-sm font-normal text-[#555259] px-3"
                                            >
                                                Pending Approvals
                                                {toggleState.pending_approvals === false ? <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5 default-dropdown" />
                                                    : <img src="/images/chevron-red-down.svg" alt="icon" className="absolute top-[22px] right-5  selected selected-dropdown" />}
                                            </button>
                                            <ul className={`dropdown-menu w-full absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${toggleState.pending_approvals ? 'overflow-auto h-32' : ''}`} aria-labelledby="territory">

                                                {toggleState.pending_approvals && AccessPrevileges.pending_approvals.map((pendingapproval) => (
                                                    <li className="pl-10 w-full pt-4" key={pendingapproval.id}>
                                                        <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3">
                                                            <input
                                                                type="checkbox"
                                                                id={`checkbox-d1${pendingapproval.id}`}
                                                                checked={ItemExist(pendingapproval.id)}
                                                                onChange={() => handleAccessPrevilege(pendingapproval)}
                                                            />
                                                            <label htmlFor={`checkbox-d1${pendingapproval.id}`} className="text-sm font-normal text-[#555259] pl-2">{CamelCase(pendingapproval.label)}</label>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                            <div className="absolute -top-[4px] left-0">
                                                <div className="relative checkbox custom-checkbox custom-checkbox1 pb-3">
                                                    <input
                                                        type="checkbox"
                                                        id="checkbox-view71"
                                                        onChange={() => handleAllPrevilage(AccessPrevileges.pending_approvals, 'Obj')}
                                                        checked={parentCheckStatus(AccessPrevileges.pending_approvals)}
                                                    />
                                                    <label htmlFor="checkbox-view71" className="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex pb-3">
                                        <div className="dropdown relative w-1/3">
                                            <button
                                                onClick={() => handleToggle('manage_invoices')}
                                                type="button"
                                                id="territory"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                className="customrotate alignLeft h-12 w-full rounded-lg outline-0 shadow-s4 bg-[#FFFFFF] text-sm font-normal text-[#555259] px-3"
                                            >
                                                Invoices
                                                {toggleState.manage_invoices === false ? <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5 default-dropdown" />
                                                    : <img src="/images/chevron-red-down.svg" alt="icon" className="absolute top-[22px] right-5  selected selected-dropdown" />}
                                            </button>
                                            <ul className={`dropdown-menu w-full absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${toggleState.manage_invoices ? 'overflow-auto h-32' : ''}`} aria-labelledby="territory">

                                                {toggleState.manage_invoices && AccessPrevileges.manage_invoices.map((invoice) => (
                                                    <li className="pl-10 w-full pt-4" key={invoice.id}>
                                                        <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3">
                                                            <input
                                                                type="checkbox"
                                                                id={`checkbox-d1${invoice.id}`}
                                                                checked={ItemExist(invoice.id)}
                                                                onChange={() => handleAccessPrevilege(invoice)}
                                                            />
                                                            <label htmlFor={`checkbox-d1${invoice.id}`} className="text-sm font-normal text-[#555259] pl-2">{invoice.label}</label>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                            <div className="absolute -top-[4px] left-0">
                                                <div className="relative checkbox custom-checkbox custom-checkbox1 pb-3">
                                                    <input
                                                        type="checkbox"
                                                        id="checkbox-viewf1"
                                                        onChange={() => handleAllPrevilage(AccessPrevileges.manage_invoices, 'Obj')}
                                                        checked={parentCheckStatus(AccessPrevileges.manage_invoices)}
                                                    />
                                                    <label htmlFor="checkbox-viewf1" className="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="relative checkbox custom-checkbox custom-checkbox1 bg-[#FFFFFF] ml-8 h-[52px] rounded-lg shadow-s4 py-4 pl-5 w-1/3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                id="checkbox-st1"
                                                checked={ItemExist(AccessPrevileges.mis_reports.id)}
                                                onChange={() => handleAllPrevilage(AccessPrevileges.mis_reports)}
                                            />
                                            <label htmlFor="checkbox-st1" className="text-sm font-normal text-[#555259] pl-2 w-full">MIS Reports</label>
                                        </div>
                                        <div className="relative checkbox custom-checkbox custom-checkbox1 bg-[#FFFFFF] ml-8 h-[52px] rounded-lg shadow-s4 py-4 pl-5 w-1/3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                id="checkbox-so2"
                                                checked={ItemExist(AccessPrevileges.manage_resources.id)}
                                                onChange={() => handleAllPrevilage(AccessPrevileges.manage_resources)}
                                            />
                                            <label htmlFor="checkbox-so2" className="text-sm font-normal text-[#555259] pl-2 w-full">Resources</label>
                                        </div>
                                    </div>
                                    <div className="flex pb-3">
                                        <div className="relative checkbox custom-checkbox custom-checkbox1 bg-[#FFFFFF] h-[52px] rounded-lg shadow-s4 py-4 pl-5 w-1/3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                id="checkbox-ms1"
                                                checked={ItemExist(AccessPrevileges.manage_settings.id)}
                                                onChange={() => handleAllPrevilage(AccessPrevileges.manage_settings)}
                                            />
                                            <label htmlFor="checkbox-ms1" className="text-sm font-normal text-[#555259] pl-2 w-full">Settings</label>
                                        </div>
                                        <div className="relative checkbox custom-checkbox custom-checkbox1 bg-[#FFFFFF] ml-8 h-[52px] rounded-lg shadow-s4 py-4 pl-5 w-1/3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                id="checkbox-sm2"
                                                checked={ItemExist(AccessPrevileges.manage_banners.id)}
                                                onChange={() => handleAllPrevilage(AccessPrevileges.manage_banners)}
                                            />
                                            <label htmlFor="checkbox-sm2" className="text-sm font-normal text-[#555259] pl-2 w-full">Promotion/ Campaign Banners</label>
                                        </div>
                                        <div className="dropdown relative w-1/3 ml-8">
                                            <button
                                                onClick={() => handleToggle('manage_cashback_transactions')}
                                                type="button"
                                                id="territory"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                className="customrotate alignLeft h-12 w-full rounded-lg outline-0 shadow-s4 bg-[#FFFFFF]  text-sm font-normal text-[#555259] px-3"
                                            >
                                                Ador Cash
                                                {toggleState.manage_cashback_transactions === false ? <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5 default-dropdown" style={{ right: '0.25rem' }} />
                                                    : <img src="/images/chevron-red-down.svg" alt="icon" className="absolute top-[22px] right-5  selected selected-dropdown" style={{ right: '0.25rem' }} />}
                                            </button>
                                            <ul className={`dropdown-menu w-full absolute  bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${toggleState.manage_cashback_transactions ? 'overflow-auto h-32' : ''}`} aria-labelledby="territory">

                                                {toggleState.manage_cashback_transactions && AccessPrevileges.manage_cashback_transactions.map((cashback) => (

                                                    <li className="pl-10 w-full pt-4" key={cashback.id}>
                                                        <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3">
                                                            <input
                                                                type="checkbox"
                                                                id={`checkbox-d1${cashback.id}`}
                                                                checked={ItemExist(cashback.id)}
                                                                onChange={() => handleAccessPrevilege(cashback)}
                                                            />
                                                            <label htmlFor={`checkbox-d1${cashback.id}`} className="text-sm font-normal text-[#555259] pl-2">{CamelCase(cashback.label)}</label>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                            <div className="absolute -top-[4px] left-0">
                                                <div className="relative checkbox custom-checkbox custom-checkbox3 pb-3">
                                                    <input
                                                        type="checkbox"
                                                        id="checkbox-viewf111"
                                                        onChange={() => handleAllPrevilage(AccessPrevileges.manage_cashback_transactions, 'Obj')}
                                                        checked={parentCheckStatus(AccessPrevileges.manage_cashback_transactions)}
                                                    />
                                                    <label htmlFor="checkbox-viewf111" className="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex pb-3">
                                        <div className="relative checkbox custom-checkbox custom-checkbox1 bg-[#FFFFFF] h-[52px] rounded-lg shadow-s4 py-4 pl-5 w-1/3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                id="checkbox-ms12"
                                                checked={ItemExist(AccessPrevileges.price_list.id)}
                                                onChange={() => handleAllPrevilage(AccessPrevileges.price_list)}
                                            />
                                            <label htmlFor="checkbox-ms12" className="text-sm font-normal text-[#555259] pl-2 w-full">Price List</label>
                                        </div>
                                        <div className="relative checkbox custom-checkbox custom-checkbox1 bg-[#FFFFFF] ml-8 h-[52px] rounded-lg shadow-s4 py-4 pl-5 w-1/3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                id="checkbox-sm121"
                                                checked={ItemExist(AccessPrevileges.stock_inventory.id)}
                                                onChange={() => handleAllPrevilage(AccessPrevileges.stock_inventory)}
                                            />
                                            <label htmlFor="checkbox-sm121" className="text-sm font-normal text-[#555259] pl-2 w-full">Stock Inventory</label>
                                        </div>
                                        <div className="relative checkbox custom-checkbox custom-checkbox1 bg-[#FFFFFF] ml-8 h-[52px] rounded-lg shadow-s4 py-4 pl-5 w-1/3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                id="checkbox-sm123"
                                                checked={ItemExist(AccessPrevileges.bulk_offer.id)}
                                                onChange={() => handleAllPrevilage(AccessPrevileges.bulk_offer)}
                                            />
                                            <label htmlFor="checkbox-sm123" className="text-sm font-normal text-[#555259] pl-2 w-full">Bulk Offers</label>
                                        </div>
                                    </div>
                                    <div className="flex pb-3">
                                        <div className="dropdown relative" style={{ width: '32%' }}>
                                            <button
                                                onClick={() => handleToggle('manage_transactions')}
                                                type="button"
                                                id="transactions'"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                className="customrotate alignLeft h-12 w-full rounded-lg outline-0 shadow-s4 bg-[#FFFFFF] text-sm font-normal text-[#555259] px-3"
                                            >
                                                Transactions
                                                {toggleState.manage_transactions === false ? <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5 default-dropdown" />
                                                    : <img src="/images/chevron-red-down.svg" alt="icon" className="absolute top-[22px] right-5  selected selected-dropdown" />}
                                            </button>
                                            <ul className={`dropdown-menu w-full absolute bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] ${toggleState.manage_transactions ? 'overflow-auto h-32' : ''}`} aria-labelledby="territory">

                                                {toggleState.manage_transactions && AccessPrevileges.manage_transactions.map((transactions) => (
                                                    <li className="pl-10 w-full pt-4" key={transactions.id}>
                                                        <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3">
                                                            <input
                                                                type="checkbox"
                                                                id={`checkbox-d1${transactions.id}`}
                                                                checked={ItemExist(transactions.id)}
                                                                onChange={() => handleAccessPrevilege(transactions)}
                                                            />
                                                            <label htmlFor={`checkbox-d1${transactions.id}`} className="text-sm font-normal text-[#555259] pl-2">{CamelCase(transactions.label)}</label>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                            <div className="absolute -top-[4px] left-0">
                                                <div className="relative checkbox custom-checkbox custom-checkbox1 pb-3">
                                                    <input
                                                        type="checkbox"
                                                        id="checkbox-viewf12"
                                                        onChange={() => handleAllPrevilage(AccessPrevileges.manage_transactions, 'Obj')}
                                                        checked={parentCheckStatus(AccessPrevileges.manage_transactions)}
                                                    />
                                                    <label htmlFor="checkbox-viewf12" className="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="flex justify-center pt-[34px]">
                                <button
                                    disabled={loading}
                                    type="submit"
                                    // onClick={(e) => handleSubmit(e)}
                                    className="text-xl font-semibold text-[#FFFFFF] h-[54px] w-[454px] bg-[#555259] rounded-lg text-center flex justify-center items-center"
                                >
                                    {loading ? <ThreeDotsLoader /> : (
                                        <>
                                            {isUpdate ? 'Update' : 'Create New'}
                                            {' '}
                                            User
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                )}
        </div>
    );
}
function mapState(state) {
    const { menuItems, foodTypes } = state;
    return { menuItems, foodTypes };
}
const actionCreators = {
    createUser: UserActions.createUser,

};
const connectUpdateAdminUser = connect(mapState, actionCreators)(UpdateAdminUser);
export { connectUpdateAdminUser as UpdateAdminUser };
